<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-overlay
        :show="showLoader"
        opacity="0.50"
        rounded="sm"
      >
        <b-card class="mb-0">
          <b-card-title class="my-1">
            ¿Olvidaste tu contraseña? 🔒
          </b-card-title>

          <!-- Subtitle -->
          <div v-if="!showSuccessMsg">
            <b-card-text class="mb-2">
              Ingrese su correo electrónico personal o institucional y le enviaremos instrucciones para restablecerla.
            </b-card-text>
          </div>

          <!-- Formulario -->
          <div v-if="!showSuccessMsg">
            <validation-observer ref="formulario">
              <b-form
                class="auth-forgot-password-form mt-2"
                @submit.prevent="validationForm"
              >
                <!-- email -->
                <b-form-group
                  label="Correo electrónico"
                  label-for="forgot-password-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="correo electrónico"
                    rules="required|email"
                  >
                    <b-form-input
                      id="forgot-password-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false:null"
                      name="forgot-password-email"
                      placeholder="ejemplo@correo.com"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- submit button -->
                <b-button
                  class="mt-2"
                  variant="primary"
                  block
                  type="submit"
                >
                  <feather-icon
                    icon="MailIcon"
                    class="mr-50"
                  />
                  <span class="align-middle">Enviar correo</span>
                </b-button>
              </b-form>
            </validation-observer>
          </div>

          <!-- Mensaje de éxito -->
          <div v-if="showSuccessMsg">
            <b-alert
              v-height-fade.appear
              variant="primary"
              class="mt-2"
              :show="showSuccessMsg"
            >
              <div class="alert-body text-center">
                <small>Hemos enviado un correo de reestablecimiento a <b>{{ userEmail }}</b>, por favor <b>siga los pasos mencionados</b> en el mismo para continuar con el proceso.</small>
              </div>
            </b-alert>
          </div>

          <!-- Redirect a ingreso -->
          <p class="text-center mt-2">
            <b-link @click="ingreso">
              <feather-icon icon="ChevronLeftIcon" /> Regresar a inicio de sesión
            </b-link>
          </p>
        </b-card>
      </b-overlay>
    <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard,
  BLink,
  BCardText,
  BCardTitle,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BOverlay,
  BAlert,
} from 'bootstrap-vue'
import { heightFade } from '@core/directives/animations'
import { ref } from '@vue/composition-api'
import { required, email } from '@validations'
import { useToast } from 'vue-toastification/composition'
import hostname from '@core/utils/http/config-hostname'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { sendMail } from './useAuth'

export default {
  components: {
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    BAlert,
  },
  directives: {
    'height-fade': heightFade,
  },
  setup() {
    const toast = useToast()
    const userEmail = ref('')
    const formulario = ref(null)
    const showLoader = ref(false)
    const showSuccessMsg = ref(false)

    //* Redirect to login
    const ingreso = () => {
      window.location.href = `${hostname().host}/${process.env.VUE_APP_SERVICE_INGRESO}`
    }

    //* Send mail
    const mail = () => {
      showLoader.value = true
      sendMail(userEmail.value)
        .then(response => {
          showLoader.value = false
          showSuccessMsg.value = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Respuesta',
              text: response,
              icon: 'MailIcon',
              variant: 'success',
            },
          },
          { timeout: 10000 })
        }, error => {
          showLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 15000 })
        })
    }

    //* Validate form
    const validationForm = () => {
      formulario.value.validate().then(success => {
        if (success) mail()
      })
    }

    return {
      // Variables
      userEmail,

      // Methods
      validationForm,
      ingreso,

      // Flags
      showLoader,
      showSuccessMsg,

      // Refs
      formulario,

      // Filters
      required,
      email,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
